'use client';
import { factory, useWindowSize, Flex, Link, DsmColor, omitText, AspectRatioKeeper, Image, Typography } from '@kohler-dsm-library/kohler-core';
import { ArrowRightBoldIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { isValidElement } from 'react';
import classes from './OverlayMenuImage.module.css.mjs';
import { getSmartCropWidth } from './OverlayMenuImage.utils.mjs';

const OverlayMenuImage = factory((props, ref) => {
  const {
    className,
    CTA,
    imagesLength = 1,
    caption,
    image,
    multiCTA,
    imageOrientation = "landscape",
    href,
    imageCTA,
    isBusinessTab = true,
    ...rest
  } = props;
  const isSmartCrop = image?.["data-mode"] === "smartcrop";
  const { width: screenWidth } = useWindowSize();
  const resolvedWidth = getSmartCropWidth({
    screenWidth,
    imagesLength,
    isSmartCrop,
    imageOrientation,
    isBusinessTab
  });
  return /* @__PURE__ */ React.createElement(
    Flex,
    {
      direction: "column",
      gap: 40,
      ref,
      className: clsx(className, "kohler-overlay-menu-image-wrapper", classes.overlayMenuImageWrapper),
      width: resolvedWidth,
      ...rest
    },
    multiCTA && multiCTA.length > 0 && /* @__PURE__ */ React.createElement(Flex, { component: "ul", direction: "column", margin: 0, gap: 20 }, multiCTA?.map((item) => /* @__PURE__ */ React.createElement(Flex, { key: item.text, component: "li", className: classes.overlayMenuCategoryLinksLink }, /* @__PURE__ */ React.createElement(
      Link,
      {
        ...omitText(item),
        underline: false,
        rightIcon: /* @__PURE__ */ React.createElement(ArrowRightBoldIcon, { withBoundingBox: false, size: "xSmall" }),
        className: classes.overlayMenuCategoryLinksLink,
        size: "small",
        textColor: DsmColor.ContentPrimary
      },
      item.text
    )))),
    /* @__PURE__ */ React.createElement(Flex, { className: clsx("kohler-overlay-menu-image", classes.overlayMenuImage, !isSmartCrop && classes.overlayMenuImageWidth) }, /* @__PURE__ */ React.createElement(
      AspectRatioKeeper,
      {
        component: "a",
        href: CTA?.href ?? href ?? void 0,
        ...imageCTA,
        aspectRatio: isSmartCrop ? "none" : imageOrientation === "landscape" ? "5:4" : "3:4"
      },
      /* @__PURE__ */ React.createElement(Image, { ...image })
    ), (caption || CTA) && /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: 5 }, caption && /* @__PURE__ */ React.createElement(
      Typography,
      {
        size: "label-regular-s",
        textColor: DsmColor.ContentSecondary,
        component: isValidElement(caption.text) ? "div" : caption.component || "p",
        ...omitText(caption)
      },
      caption.text
    ), CTA && CTA.text && /* @__PURE__ */ React.createElement(
      Link,
      {
        underline: false,
        rightIcon: /* @__PURE__ */ React.createElement(ArrowRightBoldIcon, { withBoundingBox: false, size: "xSmall" }),
        className: classes.overlayMenuImageCTA,
        size: "small",
        textColor: DsmColor.ContentPrimary,
        ...omitText(CTA)
      },
      CTA.text
    )))
  );
});

export { OverlayMenuImage };
